import { render, staticRenderFns } from "./eventos.vue?vue&type=template&id=55f0ef43"
import script from "./eventos.vue?vue&type=script&lang=js"
export * from "./eventos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports